import { createContext } from "react"

/** Elemento fixo no topo da área de conteúdo onde o `PageHeader` projeta a barra compacta durante a rolagem. */
export const PageTopBarSlotContext = createContext<HTMLElement | null>(null)
